import { TRIVELTA_PRODUCTS } from "../../utils/products";
import { STAFF_REGULATORS_LIST_ROUTE } from "./staffRegulatorsRoutes";

export const STAFF_REGULATORS_SIDER_OPTION = {
  id: "staff-regulators",
  labelKey: "COMPLIANCE_REGULATORS",
  navigate: STAFF_REGULATORS_LIST_ROUTE,
  required_product: TRIVELTA_PRODUCTS.COMPLIANCE,
  required_product_catalog_only: true,
};
